import { useState } from "react"

const useModal = (initialState = false) => {
  const [modal, setModal] = useState(initialState)
  const [modalContent, setModalContent] = useState()

  const handleModal = (content = false) => {
    setModal((state) => !state)
    if (content) {
      setModalContent(content)
    }
  }
  return { modal, handleModal, modalContent }
}

export default useModal
